import { render } from "./AddPostActive.vue?vue&type=template&id=4ee9c7b2"
import script from "./AddPostActive.vue?vue&type=script&lang=js"
export * from "./AddPostActive.vue?vue&type=script&lang=js"

import "./AddPostActive.vue?vue&type=style&index=0&id=4ee9c7b2&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__